define([
    // ここに書く
    'app/login/view/LoginPage',
    'app/login/view/TrainingLoginPage',
    // ここまで
], function () { });